import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHashtag: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconHashtag"><Path fillRule="evenodd" clipRule="evenodd" d="M10.1163 3.13174L9.63278 6.99998H15.6172L16.1318 2.88367L18.1163 3.13174L17.6328 6.99998H21V8.99998H17.3828L16.6328 15H21V17H16.3828L15.8682 21.1163L13.8837 20.8682L14.3672 17H8.38278L7.86824 21.1163L5.88369 20.8682L6.36722 17H3V15H6.61722L7.36722 8.99998H3V6.99998H7.61722L8.13176 2.88367L10.1163 3.13174ZM9.38278 8.99998L8.63278 15H14.6172L15.3672 8.99998H9.38278Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHashtag;
